import { Form, Input, Select } from "antd";
import styles from "../styles.module.css";
import { useEffect, useRef } from "react";
import useSurvey from "../../../pages/surveys/hooks/useSurvey";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setLoadingSurvey } from "../../../redux/slices/loadingSurvey";

const SurveyQuestionHeader = ({ numberPage, question, questionTypes }) => {
  const { updateSurveyQuestion, getSurveyInfo } = useSurvey();
  const { id } = useParams();
  const dispatch = useDispatch();
  const timeRef = useRef(null);
  const loadingSurvey = useSelector((state) => state.loadingSurvey);

  const updateSurveyQuestionHandler = async (values, timeout = 1000) => {
    const {
      questionsOptions,
      types_of_question,
      id_type_question,
      id: id_survey_question,
      ...cleanQuestion
    } = question;

    const data = {
      id_type_question: id_type_question.id,
      id_survey_question,
      ...cleanQuestion,
      ...values,
    };

    if (timeRef.current) {
      clearInterval(timeRef.current);
    }

    timeRef.current = setTimeout(async () => {
      dispatch(setLoadingSurvey(true));
      const res = await updateSurveyQuestion(data);
      if (res) {
        await getSurveyInfo(Number(id));
      }
      dispatch(setLoadingSurvey(false));
    }, timeout);
  };

  console.log(numberPage, question)


  useEffect(() => {}, [])

  return (
    <div className={styles["survey-question-header"]}>
      <Form.Item
        className={styles["survey-question-title"]}
        label={`Pregunta ${numberPage}`}
        name={"question_description"}
      >
        <Input
          title={loadingSurvey ? "Cargando... Por favor espere" : undefined}
          readOnly={loadingSurvey}
          style={{ borderBottom: "1px solid #000", borderRadius: 0 }}
          bordered={false}
          variant="underlined"
          onChange={(e) => {
            updateSurveyQuestionHandler({
              question_description:
                e.target.value || question.question_description,
            });
          }}
        />
      </Form.Item>

      <Form.Item label="Tipo de pregunta" name={"id_type_question"}>
        <Select
          loading={loadingSurvey}
          options={questionTypes
            ?.map((type) => ({
              label: type.type_question,
              value: type.id,
            }))
            .sort((a, b) => a.value - b.value)}
          style={{ width: 223 }}
          onChange={(value) => {
            updateSurveyQuestionHandler(
              {
                id_type_question: value,
              },
              0
            );
          }}
        />
      </Form.Item>
    </div>
  );
};

export default SurveyQuestionHeader;
